import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@mui/system';
import measurementsIcon from '#component/icon/measurements';
import { getYoungestMetrics } from '#component/device/helper';
import { getFormattedDate, getMetricsIdentifiers, isUndefinedOrNull } from '#helper';

const InfoContainer = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(),
  overflow: 'hidden',
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(100px, 1fr))',
  '& span, & svg': {
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
  }
}));

const InfoItem = styled('div')(() => ({
  minWidth: '100px',
  marginBottom: '16px',
  '&:nth-of-type(3n + 1)': {
    justifySelf: 'start'
  },
  '&:nth-of-type(3n + 2)': {
    justifySelf: 'center'
  },
  '&:nth-of-type(3n)': {
    justifySelf: 'end'
  }
}));

const IdentifierTime = styled('div')(() => ({
  color: 'gray',
  fontSize: '14px',
  width: '100px',
  whiteSpace: 'initial'
}));

const Identifiers = props => {
  const {
    device,
    account,
    loading,
    lastMetric
  } = props;

  const meta = useSelector(s => s.meta);
  const metricsIdentifiers = getMetricsIdentifiers([device], meta);

  const itemsToRender = useMemo(
    () =>
      getYoungestMetrics(lastMetric, account, metricsIdentifiers),
    [lastMetric, account, metricsIdentifiers]
  );

  return (
    <InfoContainer>
      {itemsToRender.length ? itemsToRender.map(item => (
        <InfoItem key={item.identifier}>
          {loading ? null : measurementsIcon(item.identifier, device, item.value)}
          {!isUndefinedOrNull(item.value) ?
            <span>
              {item.value}
              {item.unit}
              <IdentifierTime>
                {getFormattedDate(item.timestamp, account)}
              </IdentifierTime>
            </span> :
            null}
        </InfoItem>
      )) : (
        <div />
      )}
    </InfoContainer>
  );
};

export default Identifiers;
